import styled, { css } from 'styled-components';
import ScrollSlider from '@/components/ScrollSlider';
import TimeOffBalanceSlider from '@/components/TimeOffBalanceSlider';
import Button from '@/trio-ui/Button';
import TableComponent from '@/trio-ui/Table';
import { PTORequest } from '@/types/api';
import TimeOffCard from '../TimeOffCard';

export const ButtonCards = styled(ScrollSlider)`
  display: flex;
  justify-content: center;
  margin: 0 -6px;

  &::before {
    background: linear-gradient(to left, rgba(247, 247, 247, 0), rgb(247, 247, 247));
  }

  &::after {
    background: linear-gradient(to right, rgba(247, 247, 247, 0), rgb(247, 247, 247));
  }

  & > div {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    gap: 16px;
    overflow-y: auto;
    padding: 6px;
    width: 100%;
  }
`;

export const Card = styled(TimeOffCard)`
  width: 100%;
  min-width: 175px;
  flex-shrink: 0;
`;

export const TinyButton = styled(Button)`
  padding: 5px 16px 7px;
  font-size: 12px;
  line-height: 100%;
  position: absolute;
  top: 7%.5;
  right: 16px;
`;

export const RequestTimeoffContainer = styled.div`
  padding: 32px 0 16px;
  display: flex;
  align-items: center;
`;

export const TableTitle = styled.p`
  color: ${({ theme }) => theme.colors['neutral-100']};
  font-size: 18px;
  font-weight: 600;
  line-height: 120%;
  flex-grow: 1;
`;

export const TableSubtitle = styled.p`
  color: #1d1c1d;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 16px;
`;

export const Table = styled(TableComponent<PTORequest>)`
  thead th {
    border-top: 0 none;
  }
  tbody tr:last-child td {
    border-bottom: 0 none;
  }

  thead th:first-child,
  tbody td:first-child {
    border-left: 0 none;
  }

  thead th:last-child,
  tbody td:last-child {
    border-right: 0 none;
  }

  tbody {
    tr:not(:hover) button {
      opacity: 0;
    }

    td {
      & > div {
        display: flex;
        align-items: center;

        & > span {
          display: block;
          flex-grow: 1;
        }
      }
    }

    td:first-child svg {
      height: 20px;
      width: 20px;
      margin-right: 10px;
      fill: ${({ theme }) => theme.colors['neutral-100']};
    }

    td:last-child > div {
      display: flex;
      justify-content: space-between;
    }
  }
`;

export const RequestStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  & svg {
    width: 12px;
    height: 12px;
  }
`;

export const BalanceSlider = styled(TimeOffBalanceSlider)`
  &::before {
    background: linear-gradient(to left, rgba(247, 247, 247, 0), rgb(247, 247, 247));
  }

  &::after {
    background: linear-gradient(to right, rgba(247, 247, 247, 0), rgb(247, 247, 247));
  }
`;

const noteTypography = css`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;

export const NoNote = styled.p`
  color: ${({ theme }) => theme.colors['neutral-70']};
  ${noteTypography}

  tr:not(:hover) & {
    opacity: 0;
  }
`;

export const NoteButton = styled.button`
  cursor: pointer;
  display: flex;
  gap: 6px;
  align-items: center;
  color: ${({ theme }) => theme.colors['primary-60']};
  ${noteTypography}
  &:hover {
    color: ${({ theme }) => theme.colors['primary-40']};
  }
  & > svg {
    width: 12px;
    height: 12px;
    display: block;
  }
`;
